import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/picture-pick/high_back.webp";

function Highlights() {
  return (
    <section
      className="intro_section p-100 high_pick"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#FF6C7F" }}>Highlights</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <p>
              The highlight of iRemembered message scheduling app is the
              intuitive design and user journey that offers ease and convenience
              to users. In few simple steps users can schedule their messages to
              be sent at any given time, anywhere.
            </p>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center mt-3"
          >
            <StaticImage
              src="../../../images/case-studies/iremembered/highlights_img.png"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["png"]}
              width={1479}
              height={681}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Highlights;
